/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * てのひら眼科 Patient API
 * OpenAPI spec version: 1.0.0
 */

/**
 * 目の種別
 */
export type PatchUpneeqEyeImagesBodiesEyeType = typeof PatchUpneeqEyeImagesBodiesEyeType[keyof typeof PatchUpneeqEyeImagesBodiesEyeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchUpneeqEyeImagesBodiesEyeType = {
  right: 'right',
  left: 'left',
  both: 'both',
} as const;
